import axios from "axios";
import { BASE_URL } from "../../constant";

import {
  handleFormatResponse,
  handleFormatResponseForError,
} from "../../utility";

export function useContentRepoFetch() {
  const fetchContentRepoData = async (endpoint: string) => {
    try {
      let response = await axios.get(
        `${BASE_URL}ContentRepository/${endpoint}`
      );
      // console.log("Response: ", response?.data);
      const formattedResponse = handleFormatResponse(response);
      return formattedResponse;
    } catch (error: any) {
      // console.log("Error: ", error);
      const formattedError = handleFormatResponseForError(error);
      return formattedError;
    }
  };

  const postContentRepoData = async (endpoint: string, payload: any) => {
    try {
      let response = await axios.post(
        `${BASE_URL}ContentRepository/${endpoint}`,
        payload
      );
      // console.log("Response: ", response?.data);
      const formattedResponse = handleFormatResponse(response);
      return formattedResponse;
    } catch (error: any) {
      // console.log("Error: ", error);
      const formattedError = handleFormatResponseForError(error);
      return formattedError;
    }
  };

//   const putContentRepoData = async (endpoint: string, payload: any) => {
//     try {
//       let response = await axios.put(
//         `${BASE_URL}ContentRepository/${endpoint}`,
//         payload
//       );
//       // console.log("Response: ", response?.data);
//       const formattedResponse = handleFormatResponse(response);
//       return formattedResponse;
//     } catch (error: any) {
//       // console.log("Error: ", error);
//       const formattedError = handleFormatResponseForError(error);
//       return formattedError;
//     }
//   };

//   const deleteContentRepoData = async (endpoint: string) => {
//     try {
//       let response = await axios.delete(
//         `${BASE_URL}ContentRepository/${endpoint}`
//       );
//       // console.log("Response: ", response?.data);
//       const formattedResponse = handleFormatResponse(response);
//       return formattedResponse;
//     } catch (error: any) {
//       // console.log("Error: ", error);
//       const formattedError = handleFormatResponseForError(error);
//       return formattedError;
//     }
//   };

  return {
    fetchContentRepoData,
    postContentRepoData,
    // putContentRepoData,
    // deleteContentRepoData,
  };
}
